/**
 * @author jiangxingshang
 * @date 2024/11/18
 */
if (!customElements.get('also-buy-products')) {
  customElements.define('also-buy-products', class AlsoBuyProducts extends HTMLElement {
    constructor() {
      super();

      const productContainerElement = this.querySelector('.product-container')
      const itemTotal = productContainerElement.querySelectorAll('li').length
      if (itemTotal >= 3) {
        productContainerElement.classList.add('grid-3')
      }

      let itemIndex = 0
      this.querySelectorAll('.submit-item').forEach(item => {
        item.setAttribute('name', `items[${itemIndex}][id]`)
        itemIndex++
      })

      // 变体选择后，更新金额显示
      this.querySelectorAll('select.submit-item').forEach(select => {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex]
          const price = option.dataset.price
          const comparePrice = option.dataset.comparePrice
          const priceWrapper = select.closest('.bottom-wrapper')
          priceWrapper.querySelector('.price-sale').innerText = price
          priceWrapper.querySelector('.price-compare').innerText = comparePrice
          if (comparePrice > price) {
            priceWrapper.querySelector('.price-compare').classList.remove('hidden')
          } else {
            priceWrapper.querySelector('.price-compare').classList.add('hidden')
          }
          this.updateSubtotal()

          if (option.dataset.image) {
            option.closest('li').querySelector('.image img').src = option.dataset.image
          }
        })
      })

      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.subtotalElement = this.querySelector('.subtotal')
      this.submitButton = this.querySelector('button[name="add-all-to-cart"]')
      // this.submitButton.addEventListener('click', this._addToCart.bind(this))

      // variant没有产品标题，只能 | json后才能拿到标题
      this.querySelectorAll('.product-title').forEach(item => {
        try {
          const json = JSON.parse(item.dataset.json)
          item.innerText = json.name || json.title
        } catch (ignore) {}
      })
    }

    connectedCallback() {
      this.updateSubtotal()
    }

    get checkedProductIdArray() {
      const checkedInputs = this.querySelectorAll('input[type="checkbox"]:checked')
      const arr = []
      checkedInputs.forEach((box) => {
        arr.push(box.dataset.productId)
      })
      return arr
    }

    getVariantPrices() {
      const arr = []
      this.querySelectorAll('input[type="hidden"][data-price]').forEach(input => {
        arr.push({
          vid: input.value,
          price: parseFloat(input.dataset.price),
          comparePrice: input.dataset.comparePrice ? parseFloat(input.dataset.comparePrice) : parseFloat(input.dataset.price)
        })
      })
      this.querySelectorAll('.variant-wrapper select').forEach(select => {
        const option = select.options[select.selectedIndex]
        arr.push({
          vid: option.value,
          price: parseFloat(option.dataset.price),
          comparePrice: option.dataset.comparePrice ? parseFloat(option.dataset.comparePrice) : parseFloat(option.dataset.price)
        })
      })
      return arr
    }

    updateSubtotal() {

      let allPrice = 0
      let allComparePrice = 0
      const variantPrices = this.getVariantPrices()
      for (const vp of variantPrices) {
        allPrice += vp.price
        allComparePrice += vp.comparePrice
      }
      allPrice = allPrice.toFixed(2)
      allComparePrice = allComparePrice.toFixed(2)
      this.subtotalElement.querySelector('.price-sale').innerText = allPrice
      if (allComparePrice > allPrice) {
        this.subtotalElement.querySelector('.price-compare').classList.remove('hidden')
        this.subtotalElement.querySelector('.price-save').classList.remove('hidden')
        this.subtotalElement.querySelector('.price-compare').innerText = allComparePrice
        this.subtotalElement.querySelector('.price-save').innerText = (allComparePrice - allPrice).toFixed(2)
      } else {
        this.subtotalElement.querySelector('.price-compare').classList.add('hidden')
        this.subtotalElement.querySelector('.price-save').classList.add('hidden')
      }
    }

    async _addToCart() {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')
      this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden')

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const variantPrices = this.getVariantPrices()
      for (const vp of variantPrices) {
        formData.items.push({id: vp.vid, quantity: 1})
      }
      let response = await fetch(`${routes.cart_add_url}`, {
        body: JSON.stringify(formData),
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        }
      });

      this.submitButton.setAttribute('aria-disabled', false);
      this.submitButton.classList.remove('loading');
      this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');

      response = await response.json();
      if (response.ok) {
        if (response.status) {
          document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              errors: response.errors || response.description,
              message: response.message
            }}));
          this.handleErrorMessage(response.description);
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if(!this.error) {
          this.error = false;
          if(this.useSuccessMessage) {
            pushSuccessMessage(window.cartStrings.success);
          }

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) {
            document.body.addEventListener('drawerClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddDrawer.close();
          } else {
            this.cart.renderContents(response);
          }
          document.dispatchEvent(new CustomEvent('afterCartChanged', {
            detail: {
              cartData: response
            }
          }));
        }
      }
    }
  })
}
